declare let Scoreboard: any;

declare global {
  interface Window {
    Scoreboard: any;
  }
}

export function extendScoreboard() {
  if (lib.comsuntexsymbolsScoreboard) {
    window.Scoreboard = lib.comsuntexsymbolsScoreboard;

    const comsuntexsymbolsScoreboard_constructor =
      lib.comsuntexsymbolsScoreboard;
    const comsuntexsymbolsScoreboard_prototype =
      lib.comsuntexsymbolsScoreboard.prototype;

    lib.comsuntexsymbolsScoreboard = function () {
      this._oldConstructor = comsuntexsymbolsScoreboard_constructor;
      this._oldConstructor();

      UIUtil.createSimpleToggleButton(this.musicBtn, Scoreboard._toggleMusic);
      UIUtil.createSimpleToggleButton(this.muteBtn, Scoreboard._toggleSound);

      this.updateRound();
      this.updateGame();
      this.updateBonus();
      this.updateCorrect();

      this._progressMeter = new Meter(
        this.progressPanel.progressMeterMc.progressMeterFill,
      );

      //Bind a field for displaying Percentage
      if (
        typeof this.progressPanel.progressMeterMc.percentCompleteTxt !==
        'undefined'
      ) {
        this.progressPanel.progressMeterMc.percentCompleteTxt.displayAsPercent = true;
        this._progressMeter.bindTextField(
          this.progressPanel.progressMeterMc.percentCompleteTxt,
        );
      }

      if (UIUtil.inJavascript()) {
        UIUtil.hide(this.musicBtn);
      }
    };
    lib.comsuntexsymbolsScoreboard.prototype =
      comsuntexsymbolsScoreboard_prototype;

    const p = lib.comsuntexsymbolsScoreboard.prototype;

    p.mute = function () {
      Scoreboard._toggleSound(false, this.muteBtn);
      this.muteBtn.toggleOff();
    };

    p.showProgressPanel = function () {
      UIUtil.show(this.progressPanel, 500);
    };

    p.hideProgressPanel = function () {
      UIUtil.hide(this.progressPanel);
    };

    p.hideMusicButton = function () {
      UIUtil.hide(this.musicBtn);
    };

    p.hideMeter = function () {
      UIUtil.hide(this.progressPanel.progressMeterMc);
    };

    /* update */

    p.updateRound = function (round) {
      this._updateField('round', round);
    };
    p.updateGame = function (game) {
      this._updateField('game', game);
    };
    p.updateCorrect = function (correct) {
      this._updateField('correct', correct);
    };

    p.updateProgress = function (progress) {
      this._progressMeter.update(progress);
    };
    p.updateBonus = function (bonus) {
      if (bonus == '0') {
        this._updateField('bonus', null);
      } else {
        this._updateField('bonus', bonus);
      }
    };

    p._updateField = function (name, value) {
      const label = UIUtil.find(this.progressPanel, name + 'Lbl');
      const textField = UIUtil.find(this.progressPanel, name + 'Txt');
      if (value == null) {
        UIUtil.hide(label);
        textField.text = '';
      } else {
        UIUtil.show(label);
        textField.text = value;
      }
    };

    Scoreboard._toggleMusic = function (musicOn) {
      if (musicOn) LoadUtil.restartLoop();
      else LoadUtil.stopLoop();
    };

    Scoreboard._toggleSound = function (soundOn, btn) {
      if (soundOn) LoadUtil.unmute();
      else LoadUtil.mute();

      if (!UIUtil.inJavascript()) {
        if (soundOn) {
          UIUtil.enable(btn.parent.musicBtn);
          UIUtil.fadeTo(btn.parent.musicBtn, 1.0);
          if (btn.parent.musicBtn.value == true)
            UIUtil.setFrame(btn.parent.musicBtn, 1);
        } else {
          UIUtil.disable(btn.parent.musicBtn);
          UIUtil.setFrame(btn.parent.musicBtn, 3);
        }
      }
    };
  }
}
